import { Chart } from 'primereact/chart'; // Actuellement PrimeReact
// Futur: import { BarChart } from '@mui/x-charts/BarChart';

function BarChart({ data, config }) {

  // Configuration des options (reste similaire)
  const chartOptions = {
    scales: {
      x: { stacked: true },
      y: { stacked: true }
    },
    responsive: true,
    maintainAspectRatio: false
  };

  // NOTE POUR LA MIGRATION MUI :
  // Quand vous passerez à MUI, vous garderez ce composant, 
  // mais vous remplacerez simplement le <Chart /> par le composant MUI.
  // La structure des props (data, config) restera la même.

  return (
    <Chart
      type="bar"
      data={data}
      options={chartOptions}
      className="h-[400px] w-full"
    />
  );
}

export default BarChart;